export type ImageSizePreset = 'small' | 'medium' | 'large';

export const IMAGE_SIZE_PRESETS: readonly ImageSizePreset[] = [
  'small',
  'medium',
  'large',
] as const;

/**
 * The rendered width of each preset. The viewer owns this contract; the editor
 * reads it so its preview matches what a reader will see.
 */
export const IMAGE_SIZE_PRESET_WIDTHS: Record<ImageSizePreset, string> = {
  small: '30%',
  medium: '60%',
  large: '100%',
};

export const isImageSizePreset = (value: unknown): value is ImageSizePreset =>
  typeof value === 'string' &&
  (IMAGE_SIZE_PRESETS as readonly string[]).includes(value);
